import { ENDPOINT_BASE } from '@/config/endpoints'

/**
 * Super Agent (MolySA) endpoints are nested under the workspace path:
 *   per-project:   /api/v1.0/e/{workspaceSlug}/projects/{projectId}/super-agent[/onboard]
 *   per-workspace: /api/v1.0/e/{workspaceSlug}/super-agent[/token]
 */
export const ENDPOINT_SUPER_AGENT = `${ENDPOINT_BASE}/e`
